import { grey } from "@mui/material/colors";

const styles = {
  whiteFixedBackGround: (isSavedBrandOpen: boolean, hasBanner: boolean) => ({
    position: "fixed",
    top: hasBanner ? 100 : 60,
    left: 0,
    right: 0,
    bottom: 0,
    pl: "90px", // Leave space for left sidebar
    pr: isSavedBrandOpen ? "418px" : "68px",
  }),
  columnContainer: {
    overflowY: "auto",
    height: "calc(100vh - 60px)", // Leave space for navigation bar
  },
  columnBorder: {
    borderLeft: `1px solid ${grey[300]}`,
  },
  columnContainerMobile: {
    paddingBottom: 8,
  },
};

export default styles;
